define('store_locator_map.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('store_locator_map', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"store-locator-map-container\"><div id=\"map\" data-type=\"map\" class=\"store-locator-map\"></div></div>  ";
},"useData":true}, 'extensions/SC/Threads/3.4.5/', 'extensions/SC/Threads/3.4.5/', Handlebars);
});